import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AcademicYear } from 'data/academic-year/academic-year.modle';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: AcademicYear | null;
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: null,
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<AcademicYear>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: null,
  status: 'error',
});

const academicYearActiveSlice = createSlice({
  name: 'academicYearActive',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default academicYearActiveSlice;
